module.exports = __webpack_public_path__ + "img/pic4.525d6fb5.png";